// Services
import ProductService from "@/app/services/main/product/product-service";
import BrandService from "@/app/services/main/brands/brand-service";
import SubscriptionService from "@/app/services/main/subscription/subscription-service";
import TreatmentService from "@/app/services/main/treatment/treatment-service.js";

// Constants
import { ERROR_MSG, STATUS_CODES } from "@/app/constants/constants.js";

// Mixins
import { imageUploadMixins } from "@/app/mixins/utils/image-upload-mixins";

export const productMixins = {
  mixins: [imageUploadMixins],
  data() {
    return {
      // list
      filterStatus: null,
      statusList: [
        { id: "A", name: "ACTIVE" },
        { id: "I", name: "INACTIVE" },
      ],
      statusListType: [
        { id: "ACTIVE", name: "APPROVED" },
        { id: "PENDING", name: "PENDING" },
        { id: "DISAPPROVED", name: "DISAPPROVED" },
        { id: "INACTIVE", name: "CANCEL" },
      ],
      statusListAlt: [
        { id: "ACTIVE", name: "ACTIVE" },
        { id: "INACTIVE", name: "INACTIVE" },
      ],
      flagList: [
        { value: "true", name: "Yes" },
        { value: "false", name: "No" },
      ],
      selectedFlag: "",
      periodList: [],
      selectedPeriod: "",
      treatmentFrequencyList: [],
      isPeriodLoading: false,
      // container
      isAPILoading: false,
      isEditMode: false,
      isEditAPILoading: false,
      isAddEditProduct: false,
      // fields
      brandList: [],
      selectedBrand: "",
      isBrandsLoading: false,
      productTypeList: [],
      selectedProductType: "",
      isProductTypeLoading: false,
      subscriptionFlag: false,
      // Should be from API
      sizeList: [
        {
          id: 6,
          name: "All",
          size: "AL",
        },
        {
          id: 1,
          name: "Toy",
          size: "TY",
        },
        {
          id: 2,
          name: "Small",
          size: "SM",
        },
        {
          id: 3,
          name: "Medium",
          size: "MD",
        },
        {
          id: 4,
          name: "Large",
          size: "LG",
        },
        {
          id: 5,
          name: "Extra Large",
          size: "XL",
        },
      ],
      selectedSize: "",
      ageList: [
        {
          id: 1,
          name: "Adult",
          value: "A",
        },
        {
          id: 2,
          name: "Puppy",
          value: "P",
        },
      ],
      selectedAge: "",
      selectedFrequency: "",
    };
  },
  computed: {
    hasUploaded() {
      let img = "";

      if (this.imageUrl) {
        img = this.imageUrl;
      } else {
        img = require("@/assets/images/temporary/product-image.png");
      }

      return img;
    },
  },
  watch: {
    selectedProductType(newType) {
      if (!newType) {
        this.selectedBrand = null;
        return;
      }

      if (this.isAddEditProduct) {
        this.$v.$reset();
      }

      // clear any data it has when product List is refreshed
      this.brandList = [];

      if (!this.isEditMode) {
        this.selectedBrand = null;
      }

      newType = newType.name ? newType.name : newType;

      if (newType) {
        this.getBrandList(newType.toLowerCase());

        if (!this.isEditMode) {
          this.selectedBrand = null;
        }
      } else {
        this.selectedBrand = null;
      }
    },
    selectedFlag(newVal) {
      this.getTableContent(true);
    },
    selectedPeriod(newVal) {
      this.getTableContent(true);
    },
    filterStatus(newVal) {
      this.getTableContent(true);
    },
  },
  methods: {
    resetFields() {
      // container
      this.isAPILoading = false;
      this.isEditMode = false;
      this.isEditAPILoading = false;

      // fields
      this.subscriptionFlag = false;
      this.isPeriodLoading = false;

      // table
      this.desc = false;
      this.tableContent = {
        tableData: [],
        paginationData: {
          totalCount: null,
          page: null,
          limit: null,
          pageCount: null,
        },
      };

      // reset image
      this.resetImageFields();

      // validation
      this.$v.$reset();

      // component fields
      this.resetCustomFields();
    },
    getSubscriptionPeriodList() {
      this.isPeriodLoading = true;
      SubscriptionService.getSubscriptionPeriodList().then((res) => {
        const { ERROR_GET_SUBSCRIPTION_PERIOD_LIST } =
          this.toastMessages.subscription();
        if (res.status === STATUS_CODES.SUCCESS) {
          this.periodList = res.data;
        } else {
          this.showAPIErrorToast(ERROR_GET_SUBSCRIPTION_PERIOD_LIST, res);
        }

        this.isPeriodLoading = false;
      });
    },
    displaySubscriptionPeriod() {
      if (!this.subscriptionFlag) {
        this.monthlyPrice = "0.00";
        this.yearlyPrice = "0.00";
        this.quarterlyPrice = "0.00";
        // this.$v.monthlyPrice.$reset();
        // this.$v.quarterlyPrice.$reset();
        // this.$v.yearlyPrice.$reset();
      } else {
        this.price = "0.00";
        this.salePrice = "0.00";
        this.onSale = false;
        // this.$v.price.$reset();
      }
    },
    getBrandList(productType) {
      const queryParams = {
        productTypeName: productType,
      };

      this.isBrandsLoading = true;

      BrandService.getBrands(queryParams).then((res) => {
        if (res.status === STATUS_CODES.SUCCESS) {
          this.brandList = res.data.data;
        } else {
          this.$notify({
            group: "notifs",
            type: "error",
            title: "Something Went Wrong!",
            text: ERROR_MSG.INTERNAL_ERROR,
            closeOnClick: true,
          });
        }

        this.isBrandsLoading = false;
      });
    },
    getProductTypeList() {
      this.isProductTypeLoading = true;

      ProductService.getProductTypes().then((res) => {
        if (res.status === STATUS_CODES.SUCCESS) {
          this.productTypeList = res.data;
        } else {
          this.$notify({
            group: "notifs",
            type: "error",
            title: "Something Went Wrong!",
            text: ERROR_MSG.INTERNAL_ERROR,
            closeOnClick: true,
          });
        }

        this.isProductTypeLoading = false;
      });
    },
    getProductTreatmentFrequencyList() {
      TreatmentService.getProductTreatmentFrequency().then((res) => {
        const { ERROR_GET_TREATMENT_FREQUENCY_LIST } =
          this.toastMessages.treatment();
        if (res.status === STATUS_CODES.SUCCESS) {
          this.treatmentFrequencyList = res.data;
        } else {
          this.showAPIErrorToast(ERROR_GET_TREATMENT_FREQUENCY_LIST, res);
        }
      });
    },
    resetSalePrice() {
      this.salePrice = "0.00";
    },
  },
};
